import React from 'react';
import LeaderboardView from '../../../common/components/gamification/LeaderboardView';

const OrgLeaderboardPage = () => <LeaderboardView title="Leaderboard" />;

export default OrgLeaderboardPage;
